import { OptionProps } from "@digital/ui";
import api from "../api";


const controllerNaoConformidadeIntegracao = '/NaoConformidadeColaboradoIntegracao';


export interface Colaborador {
  id: number;
  nome: string;
  adUser: string;
}

export interface ColaboradorTableProps {
  numeroLinha: number;
  id: string;
  name: string;
  register: string;
}

export enum ColaboradoIntegracaoOuColaboradoIntegracaoAlternativo {
  ColaboradoIntegracao = 1,
  ColaboradoIntegracaoAlternativo = 2
}

export const getAllComboAprovadorAlternativo = async () => {
  return await api.get<Array<OptionProps>>(`${controllerNaoConformidadeIntegracao}/getAllCombo`);
}

export const getAllColaborador = async () => {
  return await api.get<Array<ColaboradorTableProps>>(`${controllerNaoConformidadeIntegracao}/getAll`);
}

export const getColaboradoresComAdUser = async () => {
  return await api.get<Colaborador[]>(`${controllerNaoConformidadeIntegracao}/getColaboradoresComAdUser`);
}

export const getColaboradoresComAdUserOptions = async () =>
  getColaboradoresComAdUser().then(colaboradores =>
    (colaboradores || []).map(a => ({ text: a.nome, value: a.adUser })),
  );